import klaroConfig from "./klaro/config"
import { documentReady } from "./utils/dom"
import "./klaro/klaro.scss"
import * as klaro from "klaro/dist/klaro-no-css"

window.klaroConfig = klaroConfig

window.klaro = klaro

function showOrHideKlaro() {
  const klaroElement = document.getElementById("klaro-consent")

  if (!klaroElement) return

  const excludedPrefixes = [
    "/dashboard/",
    "/accounts/",
    "/privacy-policy/",
    "/agb/",
    "/impressum/",
    "/accessibility-statement/",
    "/wellhub/",
    "/license-information/",
  ]
  const currentPath = window.location.pathname

  const shouldHide = excludedPrefixes.some((prefix) => currentPath.startsWith(prefix))

  if (shouldHide) {
    klaroElement.classList.add("klaro-hide")
  } else {
    klaroElement.classList.remove("klaro-hide")
  }
}

// The legal pages suppress the consent modal by hiding the element klaro renders into, so
// their footer button has to lift that before klaro has anywhere visible to render.
window.showKlaroModal = () => {
  document.getElementById(klaroConfig.elementID)?.classList.remove("klaro-hide")
  window.klaro?.show(window.klaroConfig, true)
}

// Runs fn once the consent modal no longer waits for an answer, so a page's own modal never
// covers it. Call it after the DOMContentLoaded setup below, which applies klaro-hide.
window.afterKlaroConsent = (fn) => {
  const element = document.getElementById(klaroConfig.elementID)
  const manager = window.klaro?.getManager(window.klaroConfig)
  if (!element || element.classList.contains("klaro-hide") || !manager || manager.confirmed) {
    fn()
    return
  }
  const watcher = {
    update(_, event) {
      if (event === "saveConsents") {
        manager.unwatch(watcher)
        fn()
      }
    },
  }
  manager.watch(watcher)
}

documentReady(() => {
  if (document.getElementById(klaroConfig.elementID)) {
    window.klaro?.setup(window.klaroConfig)
    showOrHideKlaro()

    window.addEventListener("popstate", showOrHideKlaro)
    ;["pushState", "replaceState"].forEach((method) => {
      const original = history[method]
      history[method] = function (...args) {
        const result = original.apply(this, args)
        window.dispatchEvent(new Event(method.toLowerCase()))
        return result
      }
    })

    window.addEventListener("pushstate", showOrHideKlaro)
    window.addEventListener("replacestate", showOrHideKlaro)
  }
})
